const AVAILABILITY_STATUSES = {
  AVAILABLE: 'Plenty of space',
  LIMITED: 'Less than 5 spaces',
  NONE: 'Fully Booked',
  UNAVAILABLE: 'Unavailable to Book',
};

const TIMETABLE_TIMEZONE = 'Europe/London';

module.exports = {
  AVAILABILITY_STATUSES,
  TIMETABLE_TIMEZONE,
};
